import script from "./Clientes.vue?vue&type=script&setup=true&lang=ts"
export * from "./Clientes.vue?vue&type=script&setup=true&lang=ts"

import "./Clientes.vue?vue&type=style&index=0&id=e00dd800&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e00dd800"]])

export default __exports__